/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderBigTablePageResVo } from './OrderBigTablePageResVo';
import {
    OrderBigTablePageResVoFromJSON,
    OrderBigTablePageResVoFromJSONTyped,
    OrderBigTablePageResVoToJSON,
    OrderBigTablePageResVoToJSONTyped,
} from './OrderBigTablePageResVo';

/**
 * 
 * @export
 * @interface OutboundPlanBigTableVo
 */
export interface OutboundPlanBigTableVo {
    /**
     * 出库计划日期，按自然日返回，避免被序列化成带时分秒的 UTC 时间
     * 出库计划日期
     * @type {string}
     * @memberof OutboundPlanBigTableVo
     */
    outboundDate?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    userId?: number;
    /**
     * 用户名
     * @type {string}
     * @memberof OutboundPlanBigTableVo
     */
    userName?: string;
    /**
     * 用户编号
     * @type {string}
     * @memberof OutboundPlanBigTableVo
     */
    userCode?: string;
    /**
     * 订单数量
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalOrderCount?: number;
    /**
     * 包裹数量
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalPackageCount?: number;
    /**
     * 箱数
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalBoxCount?: number;
    /**
     * CBM
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalBoxCBM?: number;
    /**
     * 托盘数量
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalPalletCount?: number;
    /**
     * 托盘CBM
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalPalletCBM?: number;
    /**
     * 总CBM
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    totalCBM?: number;
    /**
     * LCL费用 订单编号
     * @type {string}
     * @memberof OutboundPlanBigTableVo
     */
    lclFeeOrderCode?: string;
    /**
     * LCL费用 换单费
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    blChargeFee?: number;
    /**
     * LCL费用 码头操作费
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    containerHandlingFee?: number;
    /**
     * LCL费用 文件操作费
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    handlingChargeFee?: number;
    /**
     * LCL费用 保税仓提货费
     * @type {number}
     * @memberof OutboundPlanBigTableVo
     */
    bondedWarehouseDeliveryFee?: number;
    /**
     * BL号
     * @type {string}
     * @memberof OutboundPlanBigTableVo
     */
    blNo?: string;
    /**
     * 按钮权限码，含 invoicePackingDownload 新版箱单发票下载
     * @type {Array<string>}
     * @memberof OutboundPlanBigTableVo
     */
    buttonCodes?: Array<string>;
    /**
     * 订单列表
     * @type {Array<OrderBigTablePageResVo>}
     * @memberof OutboundPlanBigTableVo
     */
    orderBigTablePageResVOList?: Array<OrderBigTablePageResVo>;
}

/**
 * Check if a given object implements the OutboundPlanBigTableVo interface.
 */
export function instanceOfOutboundPlanBigTableVo(value: object): value is OutboundPlanBigTableVo {
    return true;
}

export function OutboundPlanBigTableVoFromJSON(json: any): OutboundPlanBigTableVo {
    return OutboundPlanBigTableVoFromJSONTyped(json, false);
}

export function OutboundPlanBigTableVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutboundPlanBigTableVo {
    if (json == null) {
        return json;
    }
    return {
        
        'outboundDate': json['outboundDate'] == null ? undefined : json['outboundDate'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'totalOrderCount': json['totalOrderCount'] == null ? undefined : json['totalOrderCount'],
        'totalPackageCount': json['totalPackageCount'] == null ? undefined : json['totalPackageCount'],
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
        'totalBoxCBM': json['totalBoxCBM'] == null ? undefined : json['totalBoxCBM'],
        'totalPalletCount': json['totalPalletCount'] == null ? undefined : json['totalPalletCount'],
        'totalPalletCBM': json['totalPalletCBM'] == null ? undefined : json['totalPalletCBM'],
        'totalCBM': json['totalCBM'] == null ? undefined : json['totalCBM'],
        'lclFeeOrderCode': json['lclFeeOrderCode'] == null ? undefined : json['lclFeeOrderCode'],
        'blChargeFee': json['blChargeFee'] == null ? undefined : json['blChargeFee'],
        'containerHandlingFee': json['containerHandlingFee'] == null ? undefined : json['containerHandlingFee'],
        'handlingChargeFee': json['handlingChargeFee'] == null ? undefined : json['handlingChargeFee'],
        'bondedWarehouseDeliveryFee': json['bondedWarehouseDeliveryFee'] == null ? undefined : json['bondedWarehouseDeliveryFee'],
        'blNo': json['blNo'] == null ? undefined : json['blNo'],
        'buttonCodes': json['buttonCodes'] == null ? undefined : json['buttonCodes'],
        'orderBigTablePageResVOList': json['orderBigTablePageResVOList'] == null ? undefined : ((json['orderBigTablePageResVOList'] as Array<any>).map(OrderBigTablePageResVoFromJSON)),
    };
}

export function OutboundPlanBigTableVoToJSON(json: any): OutboundPlanBigTableVo {
    return OutboundPlanBigTableVoToJSONTyped(json, false);
}

export function OutboundPlanBigTableVoToJSONTyped(value?: OutboundPlanBigTableVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'outboundDate': value['outboundDate'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'totalOrderCount': value['totalOrderCount'],
        'totalPackageCount': value['totalPackageCount'],
        'totalBoxCount': value['totalBoxCount'],
        'totalBoxCBM': value['totalBoxCBM'],
        'totalPalletCount': value['totalPalletCount'],
        'totalPalletCBM': value['totalPalletCBM'],
        'totalCBM': value['totalCBM'],
        'lclFeeOrderCode': value['lclFeeOrderCode'],
        'blChargeFee': value['blChargeFee'],
        'containerHandlingFee': value['containerHandlingFee'],
        'handlingChargeFee': value['handlingChargeFee'],
        'bondedWarehouseDeliveryFee': value['bondedWarehouseDeliveryFee'],
        'blNo': value['blNo'],
        'buttonCodes': value['buttonCodes'],
        'orderBigTablePageResVOList': value['orderBigTablePageResVOList'] == null ? undefined : ((value['orderBigTablePageResVOList'] as Array<any>).map(OrderBigTablePageResVoToJSON)),
    };
}

